module.exports = __webpack_public_path__ + "static/media/84b12ae895a9177449241d9d65b92f3c_757575.43b2fad0.svg";